import Container from '../../atoms/container/anonymousModalLogin';
import Button from '../../atoms/buttons/modalLogin';
import ListContext from '../../../../shared/components/utils/context/listContext';
import Props from '../../../../shared/types/props/button';
import Text from '../../atoms/text/anonymousModalAccount';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useCallback, useContext, useEffect, useState } from 'react';

function LoginButton({ action, index }: Props) {
  const { listIndex } = useContext(ListContext);
  const [focused, setFocused] = useState(false);

  // Event handlers

  const onPointerEnter = useCallback(() => {
    setFocused(true);
  }, []);

  const onPointerLeave = useCallback(() => {
    setFocused(listIndex === index);
  }, [listIndex]);

  // Effect hooks

  useEffect(() => {
    setFocused(listIndex === index);
  }, [listIndex]);

  return (
    <Container>
      <Text>{TranslationManager.get('MODAL.ANONYMOUS.ACCOUNT')}</Text>
      <Button
        focused={focused}
        onClick={action}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
      >
        {TranslationManager.get('MODAL.ANONYMOUS.BUTTONS.LOGIN')}
      </Button>
    </Container>
  );
}

export default LoginButton;
